import { AxiosInstance, AxiosResponse } from 'axios'

export default class FeaturesAPI {
  public _client: AxiosInstance

  constructor(axios: AxiosInstance) {
    this._client = axios
  }

  public async list(): Promise<Array<string>> {
    const result: AxiosResponse = await this._client.get(`features`)
    return result.data.data?.map((feature: any) => feature.id) ?? []
  }
}
